import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class mxStdDrawingService {
  static async getstartcavans(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDrawing?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async savecavans(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDrawing/save_content', payload)
    )
    return Callback(err, res)
  }
}
